<template>
<div>
    <!-- list-type="picture-card" -->

  <el-upload
    class="avatar-uploader"
    :action="action"
    :show-file-list="false"
    :on-success="handleAvatarSuccess"
    :on-remove="handleRemove"
    :before-upload="beforeAvatarUpload"
    :headers = "headers"
  >
      <img v-if="imgurl" :src="imgurl" class="avatar">
      <i v-else class="el-icon-plus avatar-uploader-icon"></i>
  </el-upload>
</div>

</template>
<script>
import { Upload } from 'element-ui'
export default {
  name:'uploadBox',
  props:{
    action:{
      type: String,
      default:''
    },
    value:{
      type:String,
      default: ''
    }
  },
  data(){
    return {
      
      dialogImageUrl: '',
      dialogVisible: false,

      headers:{
        'token':`${localStorage.getItem('token')};${localStorage.getItem('refresh_token')};${localStorage.getItem('access_token')}`
      }
    }
  },
  methods:{
    handleAvatarSuccess(res, file) {
      if( res.code === 0 ){
				let dt = res.data.data;
				this.imgurl = `${dt.img}`
			}else{
				this.$msg( res.msg )
			}
      this.$emit('success', this.imgurl, res)



      // this.imageUrl = URL.createObjectURL(file.raw);
    },
    beforeAvatarUpload(file) {
      // const isJPG = file.type === 'image/jpeg';
      const isLt2M = file.size / 1024 / 1024 < 2;

      // if (!isJPG) {
      //   this.$message.error('上传图片只能是 JPG 格式!');
      // }
      if (!isLt2M) {
        this.$message.error('上传图片大小不能超过 2MB!');
      }
      // return isJPG && isLt2M;
      return isLt2M;
    },
    handleRemove(file, fileList) {
      console.log(file, fileList);
    },
    // handlePictureCardPreview(file) {
    //   this.dialogImageUrl = file.url;
    //   this.dialogVisible = true;
    //   this.imageUrl = file.url;
    // }
  },
  computed:{
    imgurl:{
      get(){
        return this.value;
      },
      set(v){
        console.log( v );
        this.$emit('input',`/public/${v}`)
        return v;
      },
      catch: false
    }
  },
  components:{
    elUpload: Upload
  }
}
</script>
<style scoped>
.avatar-uploader .el-upload {
    border: 1px dashed #d9d9d9;
    border-radius: 6px;
    cursor: pointer;
    position: relative;
    overflow: hidden;
  }
  .avatar-uploader .el-upload:hover {
    border-color: #409EFF;
  }
  .avatar-uploader-icon {
    font-size: 20px;
    color: #8c939d;
    width: 150px;
    height: 150px;
    line-height: 150px;
    text-align: center;
    border: 1px dashed #e6e6e6;
  }
  .avatar {
    width: 150px;
    height: 150px;
    display: block;
  }
</style>


// WEBPACK FOOTER //
// src/components/uploadBox.vue